export default "__VITE_ASSET__CAn1uSep__"